import { options_premium__subTitle_secondaryUser } from './DomainOptionForSecondaryUser.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getUserConfiguration } from 'owa-session-store';
import store from './store/store';
import { SubscriberType } from './contracts/subscriberType';
import { HMPlusBit } from 'owa-domain-connect';
var lazyFullModule = new LazyModule(() => import('./lazyFullOptionForSecondaryUser'));
let DomainOptionForSecondaryUser: LazyOption = createLazyOption(
    {
        key: 'customemail',
        titleStringKey: options_premium__subTitle_secondaryUser,
        searchTermsStringKey: options_premium__subTitle_secondaryUser,
        hideTitleInFullOptions: false,
        isHidden: () =>
            !isFeatureEnabled('auth-domainConnect') ||
            !isFeatureEnabled('auth-PremiumDashboardApril') ||
            !getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox ||
            !(store.subscriberType == SubscriberType.Secondary) ||
            (getUserConfiguration().SessionSettings.PremiumAccountOffers & HMPlusBit) ==
                HMPlusBit ||
            !store.userInfo.isProsumerConsumerMailbox,
    },
    lazyFullModule,
    m => m.default
);
export default DomainOptionForSecondaryUser;
